import { AgentRuntimeProviderIdEnum } from '../../types/providers';
import { CLAUDE_ANTHROPIC_SKILLS } from './claude-skills';
import { CLAUDE_BUILTIN_TOOLS } from './claude-tools';
import { anthropicAgentConfig, anthropicAwsAgentConfig } from './credentials';
export { AgentRuntimeProviderIdEnum };
export const AGENT_RUNTIME_PROVIDERS = [
    {
        providerId: AgentRuntimeProviderIdEnum.Anthropic,
        displayName: 'Claude (Anthropic)',
        docsUrl: 'https://docs.anthropic.com/en/docs/agents',
        statusUrl: 'https://status.anthropic.com',
        logoFileName: { light: 'anthropic.svg', dark: 'anthropic.svg' },
        credentials: anthropicAgentConfig,
        capabilities: {
            mcpServers: true,
            tools: true,
            model: true,
            systemPrompt: true,
            skills: true,
            tokenVault: true,
        },
        availableTools: CLAUDE_BUILTIN_TOOLS,
        availableSkills: CLAUDE_ANTHROPIC_SKILLS,
    },
    {
        providerId: AgentRuntimeProviderIdEnum.AnthropicAws,
        displayName: 'Claude Platform on AWS',
        docsUrl: 'https://docs.aws.amazon.com/claude-platform/latest/userguide/setup.html',
        logoFileName: { light: 'ses.svg', dark: 'ses.svg' },
        credentials: anthropicAwsAgentConfig,
        capabilities: {
            mcpServers: true,
            tools: true,
            model: true,
            systemPrompt: true,
            skills: true,
            tokenVault: true,
        },
        availableTools: CLAUDE_BUILTIN_TOOLS,
        availableSkills: CLAUDE_ANTHROPIC_SKILLS,
    },
    {
        providerId: AgentRuntimeProviderIdEnum.NovuAnthropic,
        displayName: 'Novu Managed Claude',
        docsUrl: 'https://docs.anthropic.com/en/docs/agents',
        statusUrl: 'https://status.anthropic.com',
        logoFileName: { light: 'novu.png', dark: 'novu.png' },
        credentials: [],
        capabilities: {
            mcpServers: true,
            tools: true,
            model: true,
            systemPrompt: true,
            skills: true,
            tokenVault: true,
        },
        availableTools: CLAUDE_BUILTIN_TOOLS,
        availableSkills: CLAUDE_ANTHROPIC_SKILLS,
    },
];
export const AGENT_RUNTIME_PROVIDER_IDS = new Set(AGENT_RUNTIME_PROVIDERS.map((p) => p.providerId));
//# sourceMappingURL=agent-runtime-providers.js.map